﻿﻿export interface IClosedLoopCreateLinkRequest {
    dash: boolean;
    donor: boolean;
    donorShieldDirect: boolean;
    watr: boolean;
    followUpDonor: boolean;
}
